exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current-title{text-align:center;margin-bottom:20px}.current-title span{width:400px;height:37px;font-size:32px;font-family:NanumBarunGothicUltraLightOTF}.patient-navi{height:74px;display:flex;justify-content:center}.patient-navi li{width:274px;height:74px;border-radius:3px;margin-right:21px;font-family:NanumBarunGothicOTF;font-size:20px;line-height:74px;text-align:center}.on-btn{background-color:#4b74ff;box-shadow:0 0 10px 0 #4b74ff;color:#fff}.off-btn{background-color:#fff;color:#4b74ff;box-shadow:0 0 10px 0 hsla(0,0%,85%,.43)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a2f984a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PatientCenter/PatientLeft.vue
// module id = 231
// module chunks = 0